import React, { useRef, useState } from 'react';

import { getFormattedDuration } from 'utils/date';
import { logError } from 'shared-services/logger-service';

import IconPause from 'icons/icon-pause';
import IconPlay from 'icons/icon-play';
import IconSoundWave from 'icons/icon-sound-wave';

import './SimpleAudioPlayer.styles.css';

const SimpleAudioPlayer = ({ src, duration, dimmed, onPlay }) => {
    const audio = useRef(null);
    const [playing, setPlaying] = useState(false);

    const handlePlay = () => {
        onPlay && onPlay();
        setPlaying(true)
    };
    const handlePause = () => setPlaying(false);

    const handlePlayClick = () => {
        try {
            audio.current?.play();
        } catch (e) {
            logError('audioPlayer', e);
        }
    }

    const handlePauseClick = () => {
        audio.current?.pause();
    }

    return (
        <div className={'simple-audio-player' + (dimmed ? ' simple-audio-player-dimmed' : '')}>
            <audio src={src} ref={audio} onPlay={handlePlay} onPause={handlePause} />

            <div className="player-image">
                <IconSoundWave />
            </div>

            <div className="player-duration">
                { getFormattedDuration(duration, { onlyIfExists: true }) }
            </div>

            <div className="player-controls">
                {
                    playing ? (
                        <button className="btn btn-secondary btn-xsmall btn-colored btn-icon btn-circle" onClick={handlePauseClick}><IconPause size="15px" /></button>
                    ) : (
                        <button className="btn btn-secondary btn-xsmall btn-colored btn-icon btn-circle" onClick={handlePlayClick}><IconPlay size="16px" /></button>
                    )
                }
            </div>
        </div>
    );
}

export default SimpleAudioPlayer;
